import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdstxtApiService from '../../ApiServices/WebsiteApiService/AdstxtApiService';
import { useAuth } from "../Auth/AuthContext"; 

// Custom styles for the modal
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
        backgroundColor: '#f9f9f9',
        width: '500px',
    },
};

const AdstxtModelForm = ({ isOpen, closeModal }) => { 
    const [adsFile, setAdsFile] = useState(null);
    const [fileExists, setFileExists] = useState(false);

    const Auth = useAuth();
    const user = Auth.authState.user;

    useEffect(() => {
        const checkFileExists = async () => {
            try {
                var UserId = user.id;
                const result = await AdstxtApiService.CheckFileExists(UserId);
                var exist = result.data != null? true:false;
                setFileExists(exist);
            } catch (error) {
                console.error("Error checking file existence:", error);
                toast.error("Error checking file existence.");
            }
        };
        checkFileExists();
    }, []);

    const handleDownloadAdstxt = async () => {
        try {
            const response = await AdstxtApiService.Download();
            const blob = new Blob([response.data], { type: 'text/plain' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'ads.txt';
            link.click();
            toast.success("Downloading ads.txt...");
        } catch (error) {
            console.error("Error downloading file:", error);
            toast.error("Error downloading ads.txt file.");
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setAdsFile(file);
    };

    const handleUpload = async () => {
        if (!adsFile) {
            toast.warn("Please select a file to upload.");
            return;
        }

        var UserId = user.id;
        const formData = new FormData();
        formData.append('file', adsFile);

        try {
            const result = await AdstxtApiService.Upload(UserId, formData);
            setFileExists(true);
            toast.success(result.message || "File uploaded successfully.");
        } catch (error) {
            console.error("Error uploading file:", error);
            toast.error("Error uploading file.");
        }
    };

    return (
        <>
            <ToastContainer />
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
            >
                <div className="bg-white p-6 rounded-lg shadow-md" data-aos="fade-up">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">Adstxt Detail</h2>
                        <button onClick={closeModal} className="text-gray-600 hover:text-gray-900 font-bold text-lg">&times;</button>
                    </div>
                    <p className="mb-4 text-gray-600">
                        Proposed by GreedyGame.
                        <br /> For more info, please <a href="#contactSupport" className="text-blue-600 underline">Contact Support</a>.
                    </p>

                    {fileExists ? (
                        <button onClick={handleDownloadAdstxt}
                            className="w-full flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2">
                            Download Adstxt
                        </button>
                    ) : (
                        <>
                            <input type="file" onChange={handleFileChange} className="mb-4 w-full px-3 py-2 border border-gray-300 rounded" />
                            <button onClick={handleUpload}
                                className="w-full flex items-center justify-center text-green-500 border border-green-500 hover:bg-green-500 hover:text-white transition-colors duration-300 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2">
                                Upload Adstxt
                            </button>
                        </>
                    )}
                </div>
            </Modal>
        </>
    );
};

export default AdstxtModelForm;
